export default {
  UPDATE_CHECK: 'WAREHOUSE/UPDATE_CHECK',
  DELETE_CHECK: 'WAREHOUSE/DELETE_CHECK'
};
